export default {"src":"/_next/static/media/garden.59f6c664.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};